export default __webpack_public_path__ + "static/media/Armband of Infernal Zeal.ea1f8b45.jpg";